import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../theme';
import { FA_SELECTOR } from '../../styles/variables';

export const useCustomGroupAutocompleteStyles = createStyles(({ token }) => ({
  popupOverlay: {
    '&.ant-popover': {
      padding: 0,
      paddingRight: ThemeSpaces.SPACE_NORM,
      minWidth: 280,
      maxWidth: '100vw',

      '.ant-popover-content': {
        '.ant-popover-inner': {
          borderRadius: token.borderRadiusSM,
          boxShadow: `0 1px 20px ${ThemeColors.COLOR_GREY_BLUISH3}`,
          border: `1px solid ${ThemeColors.COLOR_WHITE}`,
          backgroundColor: ThemeColors.COLOR_WHITE2_5,
          overflow: 'hidden',

          '.ant-popover-inner-content': {
            padding: 0,

            '.Scrollbar': {
              maxHeight: 240,
            },
          },
        },
      },

      '.CustomGroupAutocomplete-Group': {
        '& + .CustomGroupAutocomplete-Group': {
          marginTop: ThemeSpaces.SPACE_NORM0_5,
        },
      },

      '.CustomGroupAutocomplete-GroupHeader': {
        fontSize: token.fontSizeLG,
        fontWeight: 'bold',
        color: ThemeColors.COLOR_GREY_BLUISH,
        padding: `0 ${ThemeSpaces.SPACE_NORM}px`,

        [FA_SELECTOR]: {
          width: 10,
        },
      },

      '.Clickable': {
        padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
        lineHeight: '30px',
        fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
        fontWeight: 500,
        color: ThemeColors.COLOR_BLACK,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        '&:hover, &.active': {
          backgroundColor: hexToRgbaWithAlpha(ThemeColors.COLOR_BLUE2, 0.26),
        },

        '&.disabled': {
          cursor: 'not-allowed',
        },
      },
    },
  },
}));
